import { LocationConfig } from '../../application/entities/location-config.entity';
import { LocationConfigChangeSet } from '../../application/entities/location-config-change-set.entity';
import { LocationConfigBatchRequestDto } from '../dto/location-config-batch-request.dto';
import { LocationConfigResponseDto } from '../dto/location-config-response.dto';

/**
 * `dto.data` ES el LocationConfig directamente (ver nota en `LocationConfigResponseDto`):
 * `StandardResponseUtils.wrap` solo anida bajo un fieldName para List/Page, no para un DTO único.
 */
export function toLocationConfig(dto: LocationConfigResponseDto): LocationConfig {
  const data = dto.data;
  return {
    organizationUuid: data.organizationUuid,
    organizationName: data.organizationName,
    levels: (data.levels ?? []).map((l) => ({
      uuid: l.uuid,
      name: l.name,
      displayOrder: l.displayOrder,
      parentLevelUuid: l.parentLevelUuid ?? null,
      active: l.active,
      icon: l.icon,
      locationCount: l.locationCount,
    })),
    nodes: (data.nodes ?? []).map((n) => ({
      uuid: n.uuid,
      name: n.name,
      code: n.code ?? null,
      levelUuid: n.levelUuid,
      displayOrder: n.displayOrder,
      parentUuid: n.parentUuid ?? null,
      active: n.active,
      childCount: n.childCount,
      analysisCount: n.analysisCount,
      deletable: n.deletable,
    })),
  };
}

export function toBatchRequestDto(changes: LocationConfigChangeSet): LocationConfigBatchRequestDto {
  return {
    levels: changes.levels.map((c) => ({
      op: c.op,
      tempId: c.tempId,
      uuid: c.uuid,
      name: c.name,
      parentLevelRef: c.parentLevelRef,
      active: c.active,
      icon: c.icon,
    })),
    locations: changes.locations.map((c) => ({
      op: c.op,
      tempId: c.tempId,
      uuid: c.uuid,
      name: c.name,
      code: c.code,
      levelRef: c.levelRef,
      parentRef: c.parentRef,
      active: c.active,
    })),
  };
}
